import { render, staticRenderFns } from "./complaintBox.vue?vue&type=template&id=e91b68a8"
import script from "./complaintBox.vue?vue&type=script&lang=js"
export * from "./complaintBox.vue?vue&type=script&lang=js"
import style0 from "./complaintBox.vue?vue&type=style&index=0&id=e91b68a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports